import { carouselItems } from '@/mocks/homeData';

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="mx-auto max-w-[1280px]">
          <div className="text-center mb-10 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
              焦点专题
            </h2>
            <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
              精选焦点内容与主题活动，不错过每一个精彩瞬间
            </p>
          </div>

          <div className="flex flex-col gap-4 md:gap-5">
            {carouselItems.map((item, i) => (
              <a
                key={i}
                href={i === 2 ? '#cards' : '#index'}
                className="group flex flex-col md:flex-row bg-background-50 rounded-xl border border-background-200/60 overflow-hidden hover:border-primary-200 transition-all duration-300 no-underline cursor-pointer"
              >
                <div className="w-full md:w-[320px] lg:w-[380px] aspect-[2/1] md:aspect-auto flex-shrink-0 overflow-hidden">
                  <img
                    src={item.cover}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    onError={(e) => {
                      (e.currentTarget as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                  <div className="flex flex-wrap items-center gap-2 mb-2">
                    <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      {item.subtitle}
                    </span>
                    <span className="inline-block px-2.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-lg md:text-xl font-heading font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                  <div className="mt-4">
                    <span className="whitespace-nowrap inline-flex items-center gap-1.5 text-sm font-medium text-primary-500">
                      了解详情
                      <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}